import React from 'react';
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import {Button, Checkbox, Modal} from "semantic-ui-react";
import {connect} from "react-redux";
import BillingGroupsListRow from "./BillingGroupsListRow";
import BillingGroupForm from "../../add-edit/components/BillingGroupForm";
import {addBillingGroup, toggleBillingGroupModal, validateBillingGroupForm} from "../../add-edit/actions/AddEditBillingGroupActions";
import {BGSortFields} from "../constants/BillingGroupActionConstants";
import {billingGroupsTableSearch, toggleBGSort} from "../actions/BillingGroupActions";
import {TableSearch} from "../../../common/components/TableSearch";

export class BillingGroupsTable extends React.Component {

    static propTypes = {
        BillingGroups: PropTypes.array,
    }

    handleSort = (sortKey) => {
        this.props.changeBGSort(sortKey);
    }


    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox
                    disabled
                />
            </Table.Header>,
            <Table.Header key="name" sortKey={BGSortFields.BG_NAME}>Name</Table.Header>,
            <Table.Header key="base_price" sortKey={BGSortFields.BASE_PRICE}>Base Price</Table.Header>,
            <Table.Header key="country_count" sortKey={BGSortFields.COUNTRY_COUNT}>Country Count</Table.Header>,
            <Table.Header key="services_count" sortKey={BGSortFields.SERVICES_COUNT}>Services Count</Table.Header>,
            <Table.Header key="volume_aggregation_type" sortKey={BGSortFields.VOLUME_AGGREGATION}>Volume Aggregation</Table.Header>,
            <Table.Header key="last_updated" sortKey={BGSortFields.LAST_UPDATED}>Last Updated</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        return this.props.BillingGroups.map(billingGroup => (
            <BillingGroupsListRow
                key={billingGroup.id}
                billingGroupID={billingGroup.id}
                billingGroupName={billingGroup.billing_group_name}
                billingGroupInvoiceName={billingGroup.invoice_name}
                billingGroupCurrency={billingGroup.currency}
                billingGroupBasePrice={billingGroup.base_price}
                billingGroupCountryCount={billingGroup.country_count}
                billingGroupServicesCount={billingGroup.services_count}
                billingGroupVolumeAggregation={billingGroup.volume_aggregation_type}
                billingGroupLastUpdated={billingGroup.last_updated}
            />
        ));
    }

    handleAddBillingGroupClick = () => {
        this.props.addBillingGroupModal();
    }

    handleBillingGroupCloseModal = () => {
        this.props.toggleAddBillingGroupModal();
    }

    handleAddBillingGroupFormSubmit = () => {
        const { billingGroupObj } = this.props;
        this.props.validateBillingGroup(billingGroupObj);
    }

    handleBGTableSearch = (e) => {
        this.props.typeAheadSearchBG(e.target.value)
    }

    render() {
        return (
            <div>
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Button
                        disabled={true}
                        icon="file pdf outline" size="big"
                    />
                    <Button
                        icon="file excel outline" size="big"
                        disabled={true}
                    />
                    <Button
                        style={{float: "right"}}
                        color="blue"
                        icon="add"
                        content="Add a new Billing Group"
                        onClick={this.handleAddBillingGroupClick}
                    />
                </div>
                <div className="data-services-list-container">
                    <TableSearch
                        handleSearch={this.handleBGTableSearch}
                    />
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table sortable"
                            currSortKey={this.props.bgSortKey}
                            sortDirection={this.props.bgSortDirection}
                            headers={this.tableHeaders}
                            onSort={this.handleSort}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.toggleModal}
                >
                    <Modal.Header>
                        {"Add a New Billing Group"}
                    </Modal.Header>
                    <Modal.Content>
                        <BillingGroupForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleBillingGroupCloseModal}
                        >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleAddBillingGroupFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_billing_groups: state.veritas.billingGroups.all_billing_groups,
    bgSortDirection: state.veritas.billingGroups.bgSortDirection,
    bgSortKey: state.veritas.billingGroups.bgSortKey,
    filtered_all_billing_groups: state.veritas.billingGroups.filtered_all_billing_groups,
    billingGroupObj: state.veritas.addEdit.addEditBillingGroup.billingGroupObject,
    toggleModal: state.veritas.addEdit.addEditBillingGroup.toggleModal
});

const mapDispatchToProps = dispatch => ({
    addBillingGroupModal: () => {dispatch(addBillingGroup())},
    toggleAddBillingGroupModal: () => {dispatch(toggleBillingGroupModal())},
    validateBillingGroup: (billingGroupObj) => {dispatch(validateBillingGroupForm(billingGroupObj))},
    changeBGSort: (sortKey) => {dispatch(toggleBGSort(sortKey))},
    typeAheadSearchBG: (value) => {dispatch(billingGroupsTableSearch(value))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingGroupsTable)
